import React from "react";

const ArrowRight = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.24182 1.20349L9.03836 5.00003L5.24182 8.79658"
        stroke="currentColor"
        strokeWidth="0.769231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.03843 5L0.961548 5"
        stroke="currentColor"
        strokeWidth="0.769231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowRight;
